<template>
    <div style="padding: 20px;"><b>UserAgent string:</b> {{ userAgent }} </div>
</template>

<script>
export default {
    userAgent : "userAgent",

    data() {
        return{
       
            userAgent : "not known"
        };
       
    },
    methods: {
        setShellStatus() {
           this.userAgent = window.navigator.userAgent;
           console.log("Running in shell:" + this.userAgent)
        } 
    }
    
}
</script>
